import React, { useState } from "react";
import "./sign-up.css";
import CustomInput from "../../ui/inputs";
import Spacer from "../../ui/spacer";
import MainButton from "../../ui/main-button";
import { AppColors } from "../../utils/global-constants";
import { useNavigate } from "react-router";

const SignupScreen = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [profileImage, setProfileImage] = useState({
    src: "https://plus.unsplash.com/premium_photo-1683865776032-07bf70b0add1?q=80&w=1632&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  });
  const _handleImageUpload = (event) => {
    const file = event.target.files[0];
    file.src = URL.createObjectURL(file);
    console.log(file);
    setProfileImage(file);
  };

  const _handleSignUp = () => {
    navigate("/home");
  };

  return (
    <div className="sign-up-container">
      <div className="sign-up-container-content">
        <div className="sign-up-container-content-wrapper">
          <p className="sign-up-container-content-wrapper-title">Sign Up</p>
          <div onClick={() => document.getElementById("profile-image").click()}>
            <input
              type="file"
              id="profile-image"
              accept="image/*"
              alt="Image upload"
              style={{ display: "none" }}
              onChange={_handleImageUpload}
            />
            <img
              src={profileImage.src}
              alt="Profile"
              className="sign-up-container-content-wrapper-profile-image"
            />
            <p
              style={{ color: AppColors.main }}
              className="sign-up-container-content-wrapper-profile-image-text"
            >
              {profileImage.src
                ? "Change Profile Image"
                : "Upload Profile Image"}
            </p>
          </div>
          <Spacer />
          <CustomInput
            placeholder="Enter your email"
            label="Email"
            icon="mail"
            onChange={(e) => setEmail(e.target.value)}
            value={email}
          />
          <Spacer />
          <CustomInput
            placeholder="Enter your username"
            label="Username"
            icon="person"
            onChange={(e) => setUsername(e.target.value)}
            value={username}
          />
          <Spacer />
          <CustomInput
            placeholder="Enter your password"
            label="Password"
            icon="lock-closed"
            password
            onChange={(e) => setPassword(e.target.value)}
            value={password}
          />
          <Spacer />
          <CustomInput
            placeholder="Confirm Password"
            label="Confirm Password"
            password
            icon="lock-closed"
            onChange={(e) => setConfirmPassword(e.target.value)}
            value={confirmPassword}
          />
          <Spacer height={40} />
          <MainButton text="Sign Up" onClick={_handleSignUp} />
          <div
            className="sign-up-container-content-wrapper-login"
            onClick={() => navigate("/")}
          >
            <p style={{ color: AppColors.white }}>Already have an account?</p>
            <p style={{ color: AppColors.main, marginLeft: "5px" }}>Login</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignupScreen;
